// Generated by ReScript, PLEASE EDIT WITH CARE

import * as QrCodeGeneratorJs from "./QrCodeGenerator.js";

function toSvgDataUri(prim) {
  return QrCodeGeneratorJs.qrToSvgDataUri(prim);
}

export {
  toSvgDataUri ,
}
/* ./QrCodeGenerator.js Not a pure module */
